<template>
  <div class="countdown">
    <img src="~/assets/images/reader/icon-reader-clock.svg" alt="">
    <van-count-down :time="remainingTime" format="HH:mm:ss" @finish="onFinish" ref="countDown">
      <template #default="timeData">
        <span :style="{fontSize:size + 'px', color:fontColor, marginBottom: '2px',display:'inline-block'}" class="block top_2">{{ formatTime(timeData.hours) }}</span>
        <span :style="{fontSize:size + 'px', color:fontColor, marginBottom: '2px',display:'inline-block'}" class="colon top_2">:</span>
        <span :style="{fontSize:size + 'px', color:fontColor, marginBottom: '2px',display:'inline-block'}" class="block top_2">{{ formatTime(timeData.minutes) }}</span>
        <span :style="{fontSize:size + 'px', color:fontColor, marginBottom: '2px',display:'inline-block'}" class="colon top_2">:</span>
        <span :style="{fontSize:size + 'px', color:fontColor, marginBottom: '2px',display:'inline-block'}" class="block top_2">{{ formatTime(timeData.seconds) }}</span>
      </template>
    </van-count-down>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import 'vant/es/count-down/style'

const props = defineProps({
  cycleDuration: {
    type: Number,
    default: 12 * 60 * 60 * 1000 // 默认 12 小时
  },
  size: {
    type: Number,
    default: 11
  },
  fontColor: {
    type: String,
    default: '#fff'
  }
})

const emit = defineEmits(['finish'])

const countDown = ref(null)
const remainingTime = ref<number>(props.cycleDuration)

// 格式化数字为两位数
const formatTime = (n: number) => (n < 10 ? '0' + n : n)

// 倒计时结束
function onFinish() {
  emit('finish') // 向父组件抛出事件
}

// 重置倒计时（可从外部调用）
const reset = () => {
  remainingTime.value = props.cycleDuration
  countDown.value?.reset?.()
}

defineExpose({ reset })
</script>

<style scoped lang="scss">
.countdown {
  text-align: center;
  font-weight: bold;
  font-family: 'SFPro', 'SFPro';
  line-height: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;
  .top_2 {
    margin-bottom: 2px;
  }
}
.countdown img {
  width: 14px;
  height: 14px;
}
</style>
